// Keys are a setName to include in icon requests and iconData retrieval.
// Values are the translation key used to display the section in the selector.
// Use a value of `undefined` to omit that set from being displayed in the UI.
// Example: include the key of all versions of FontAwesome. The newest version
// will have the value 'fontAwesome' and older versions' value will be
// `undefined`. All versions' iconData will be fetched and only the newest set
// will be shown in the selector.
export const iconSetNames = {
  'fontawesome-5.14.0': undefined,
  'fontawesome-6.4.2': 'fontAwesome'
};
export const sectionDisplayNames = Object.assign({}, iconSetNames, {
  frequentlyUsed: 'frequentlyUsed'
});
export const IconTypes = {
  SOLID: 'SOLID',
  REGULAR: 'REGULAR'
};
export const PurposeValues = {
  SEMANTIC: 'semantic',
  DECORATIVE: 'decorative'
};
export const FREQUENTLY_USED_LIMIT = 14;
export const ICON_STORE_KEYS = ['frequently', 'last'];
export const ICON_NAMESPACE = 'rich-text.icon';